import { useMemo } from 'react'
import { SIDEBAR_NAV, type SidebarEntry } from '@/constants/navigation'
import { useAuth } from '@/hooks/useAuth'
import type { PermissionKey } from '@/types/permission.types'

/** Permission-filtered navigation shared by every desktop and mobile menu. */
export function useVisibleNavigation(): SidebarEntry[] {
  const { hasPermission, user } = useAuth()
  const isSuper = user?.role === 'super_admin'

  return useMemo(() => {
    const canAccess = (permission?: PermissionKey) =>
      !permission || isSuper || hasPermission(permission)

    return SIDEBAR_NAV.map((entry) => {
      if (entry.type === 'item') {
        return canAccess(entry.permission) ? entry : null
      }

      const children = entry.children.filter((child) => canAccess(child.permission))
      return children.length > 0 ? { ...entry, children } : null
    }).filter(Boolean) as SidebarEntry[]
  }, [hasPermission, isSuper])
}
